module.exports = __webpack_public_path__ + "static/advaith-b5947c1c74d3c8fbe3ea7b532a39b296.jpg";